import React from 'react';
import './ImageStyleSheet.css';

function uml4() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/umass4.jpeg" className='img-view'/>
        </div>
    )
}

export default uml4
